import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { history } from '../store'

import { updateCustomer } from '../actions/customers'
import LicenseTypeIcon from './LicenseTypeIcon'

import "../styles/QRsAdminView.css" // reuse QR styles for card-list layout

class CustomerCardList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      filters: {
        customer: '',
        group: '',
        country: '',
        type: '',
        licenseType: '',
        vertical: ''
      },
      filterOpen: true
    }

    this.handleWhatsAppToggle = this.handleWhatsAppToggle.bind(this)
    this.handleSMSToggle = this.handleSMSToggle.bind(this)
  }

  goTo(id, e) {
    history.push(`/customers/${id}`)
  }

  handleFilterChange(filterKey, value) {
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        [filterKey]: value
      }
    }))
  }

  handleWhatsAppToggle(customer, e) {
    e.stopPropagation()
    const { updateCustomer } = this.props
    const newValue = !customer.WhatsAppCommunications
    updateCustomer(customer._id, { WhatsAppCommunications: newValue })
  }

  handleSMSToggle(customer, e) {
    e.stopPropagation()
    const { updateCustomer } = this.props
    const newValue = !customer.SMSCommunications
    updateCustomer(customer._id, { SMSCommunications: newValue })
  }

  render() {
    const { filters, filterOpen } = this.state
    const { customers } = this.props
    if (!customers) return null

    const filteredCustomers = customers.filter(customer => {
      const { customer: customerFilter, group: groupFilter, country: countryFilter, mode: modeFilter, type: typeFilter, licenseType: licenseTypeFilter, vertical: verticalFilter } = filters
      if (customerFilter && (!customer.Fullname || !customer.Fullname.toLowerCase().includes(customerFilter.toLowerCase()))) return false
      if (groupFilter && (!customer.Group || !customer.Group.toLowerCase().includes(groupFilter.toLowerCase()))) return false
      if (countryFilter && (!customer.Country || !customer.Country.toLowerCase().includes(countryFilter.toLowerCase()))) return false
      if (modeFilter && (!customer.BusinessModel || !customer.BusinessModel.toLowerCase().includes(modeFilter.toLowerCase()))) return false
      if (typeFilter && (!customer.Type || !customer.Type.toLowerCase().includes(typeFilter.toLowerCase()))) return false
      if (licenseTypeFilter && (!customer.LicenseType || customer.LicenseType !== licenseTypeFilter)) return false
      if (verticalFilter && (!customer.Vertical || customer.Vertical !== verticalFilter)) return false
      return true
    })

    return (
      <div>
        <div className="qrs-admin-filter-card">
          <div className="qrs-admin-filter-header" onClick={() => this.setState(prev => ({ filterOpen: !prev.filterOpen }))}>
            <h3><i className="fas fa-filter"></i> Filtros</h3>
            <i className={`fas fa-chevron-down toggle-icon ${filterOpen ? 'open' : ''}`}></i>
          </div>

          {filterOpen && (
            <div className="qrs-admin-filter-body">
              <div className="filter-grid">
                <div className="filter-group">
                  <label>Cliente</label>
                  <input type="text" placeholder="Buscar por cliente..." value={filters.customer} onChange={e => this.handleFilterChange('customer', e.target.value)} />
                </div>

                <div className="filter-group">
                  <label>Licencia</label>
                  <select value={filters.licenseType} onChange={e => this.handleFilterChange('licenseType', e.target.value)}>
                    <option value="">Todas</option>
                    <option value="BASIC">Básica</option>
                    <option value="PRO">Pro</option>
                  </select>
                </div>

                <div className="filter-group">
                  <label>Grupo</label>
                  <input type="text" placeholder="Grupo" value={filters.group} onChange={e => this.handleFilterChange('group', e.target.value)} />
                </div>

                <div className="filter-group">
                  <label>País</label>
                  <input type="text" placeholder="País" value={filters.country} onChange={e => this.handleFilterChange('country', e.target.value)} />
                </div>

                <div className="filter-group">
                  <label>Modo</label>
                  <select value={filters.mode} onChange={e => this.handleFilterChange('mode', e.target.value)}>
                    <option value="">Todos</option>
                    <option value="REVENUE SHARE">REVENUE SHARE</option>
                    <option value="SPACE RENTAL">SPACE RENTAL</option>
                    <option value="SALE">VENTA</option>
                    <option value="RENTAL">ALQUILER</option>
                  </select>
                </div>

                <div className="filter-group">
                  <label>Tipo</label>
                  <select value={filters.type} onChange={e => this.handleFilterChange('type', e.target.value)}>
                    <option value="">Todos</option>
                    <option value="LICENCIA_BASICA">LICENCIA BÁSICA</option>
                    <option value="LICENCIA_PRO">LICENCIA PRO</option>
                    <option value="GROUP">GROUP</option>
                  </select>
                </div>
                <div className="filter-group">
                  <label>Vertical</label>
                  <select value={filters.vertical} onChange={e => this.handleFilterChange('vertical', e.target.value)}>
                    <option value="">Todas</option>
                    <option value="Themepark">Waterpark/themepark</option>
                    <option value="Ski">Ski</option>
                    <option value="FEC">FEC</option>
                    <option value="Museum">Museum</option>
                    <option value="Stadium">Stadium</option>
                    <option value="Zoo">Aquarium/zoo</option>
                    <option value="Hotel">Hotel</option>
                    <option value="Gym">Gym</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div className="filter-group filter-actions">
                  <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                    <button type="button" className="btn btn-light" onClick={() => this.setState({ filters: { customer: '', group: '', country: '', type: '', licenseType: '' } })}>Limpiar</button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="qrs-admin-list-header">
          <div className="qrs-header-col col-id">Cliente</div>
          <div className="qrs-header-col col-versions">Licencia</div>
          <div className="qrs-header-col col-customer">Grupo</div>
          <div className="qrs-header-col col-zone">País</div>
          <div className="qrs-header-col col-payments">SLA</div>
          <div className="qrs-header-col col-nightscan">Vertical</div>
          <div className="qrs-header-col col-payments">Contacto</div>
          <div className="qrs-header-col col-versions">Modo</div>
          <div className="qrs-header-col col-versions">Tipo</div>
          <div className="qrs-header-col col-actions">WhatsApp</div>
          <div className="qrs-header-col col-actions">SMS</div>
        </div>

        <div className="qrs-admin-list">
          {filteredCustomers.sort((a, b) => a.Fullname.localeCompare(b.Fullname)).map(customer => {
            if (!(customer.Type === 'GENERAL' || customer.Type === 'LICENCIA_BASICA' || customer.Type === 'LICENCIA_PRO' || customer.Type === 'GROUP')) return null
            const statusClass = customer.SLA ? 'ENABLED' : 'DISABLED'

            return (
              <div key={customer._id} className="qrs-admin-card" onClick={e => this.goTo(customer._id, e)}>
                <div className="qrs-admin-row">
                  <div className={`qrs-admin-status-bar ${statusClass}`}></div>
                  <div className="qrs-admin-content">

                    <div className="qrs-admin-machine-id">
                      <div className="qrs-admin-code">{customer.Fullname}</div>
                      <div className="qrs-admin-sub">{customer._id}</div>
                    </div>

                    <div className="qrs-admin-machine-versions">
                      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                        <LicenseTypeIcon type={customer.Type === 'LICENCIA_PRO' ? 'PRO' : 'BASIC'} />
                        <div style={{ fontSize: 14, fontWeight: 600 }}>{customer.Type === 'LICENCIA_PRO' ? 'Pro' : 'Básica'}</div>
                      </div>
                    </div>

                    <div className="qrs-admin-machine-customer">
                      <div style={{ fontWeight: 600 }}>{customer.Group || '-'}</div>
                    </div>

                    <div className="qrs-admin-machine-zone">
                      <div className="qrs-admin-zone">{customer.Country || '-'}</div>
                    </div>

                    <div className="qrs-admin-machine-payments">
                      <div className="qrs-admin-sub">{(() => {
                        if (!customer.SLA || !this.props.slas) return '--'
                        const sla = this.props.slas.find(s => s._id === customer.SLA)
                        if (!sla) return '--'
                        return sla.zone === 'ES_PENINSULA' ? 'ES Pen.' : sla.zone === 'ES_ISLANDS' ? 'ES Islas' : sla.zone === 'EU_ZONE1' ? 'EU Z1' : sla.zone === 'EU_ZONE2' ? 'EU Z2' : sla.zone
                      })()}</div>
                    </div>

                    <div className="qrs-admin-machine-nightscan">
                      <div className="qrs-admin-sub">{customer.Vertical || '-'}</div>
                    </div>

                    <div className="qrs-admin-machine-payments">
                      <div className="qrs-admin-sub">
                        <div>{customer.Phone || '-'}</div>
                        <div>{customer.Email || '-'}</div>
                      </div>
                    </div>

                    <div className="qrs-admin-machine-versions">
                      <div className="qrs-admin-sub">{customer.BusinessModel || '-'}</div>
                    </div>

                    <div className="qrs-admin-machine-versions">
                      <div className="qrs-admin-sub">{customer.Type || '-'}</div>
                    </div>

                    <div className="qrs-admin-machine-actions">
                      <div className={`qrs-toggle ${customer.WhatsAppCommunications ? 'enabled' : 'disabled'}`} onClick={(e) => { e.stopPropagation(); this.handleWhatsAppToggle(customer, e); }} title={customer.WhatsAppCommunications ? 'Click para deshabilitar' : 'Click para habilitar'}>
                        <div className="qrs-toggle-knob" />
                        <span className="qrs-toggle-label">{customer.WhatsAppCommunications ? 'SÍ' : 'NO'}</span>
                      </div>
                    </div>

                    <div className="qrs-admin-machine-actions">
                      <div className={`qrs-toggle ${customer.SMSCommunications ? 'enabled' : 'disabled'}`} onClick={(e) => { e.stopPropagation(); this.handleSMSToggle(customer, e); }} title={customer.SMSCommunications ? 'Click para deshabilitar' : 'Click para habilitar'}>
                        <div className="qrs-toggle-knob" />
                        <span className="qrs-toggle-label">{customer.SMSCommunications ? 'SÍ' : 'NO'}</span>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateCustomer: bindActionCreators(updateCustomer, dispatch),
})

export default connect(null, mapDispatchToProps)(CustomerCardList)